module.exports = __webpack_public_path__ + "static/media/icon-timer.22577c10.svg";